import { gql } from '@apollo/client'
import { SABRE_PRODUCT_FRAGMENT } from '../fragments'

export const SABRE_UPDATE_PRODUCT = gql`
  mutation UpdateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      product {
        ...Product
      }
    }
  }
  ${SABRE_PRODUCT_FRAGMENT}
`
